<template>
  <div>
    <b-card
      v-if="driverData"
      no-body
      class="px-1 py-1
       driver-view__sticky-info"
    >
      <b-card-title class="mb-1 font-weight-bold text-success">
        E-Wallet
      </b-card-title>
      <b-row
        v-for="Wallet in driverWallet.eWallet"
        :key="Wallet.id"
      >
        <b-col
          md="3"
          class="d-flex align-items-center"
        >
          <div class="d-flex align-items-center">
            <feather-icon
              icon="CreditCardIcon"
              class="mr-75"
            />
            <span class="font-weight-bold mr-1">Type:</span>
            {{ Wallet.vendor }}
          </div>
        </b-col>
        <b-col
          md="2"
          class="d-flex align-items-center"
        >
          <div
            v-for="(value, name) in Wallet.meta"
            :id="value"
            :key="value"
            class="d-flex align-items-center"
          >
            <feather-icon
              icon="KeyIcon"
              class="mr-75"
            />
            <span class="font-weight-bold mr-1">{{ name }}</span>
            {{ value }}
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BCardTitle,
} from 'bootstrap-vue'
import {
  computed,
} from '@vue/composition-api'
import store from '@/store'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BCardTitle,
  },
  props: {
    driverWallet: {
      type: Object,
      default: () => {},
    },
  },
  setup(_, ctx) {
    const fetchingLicenses = computed(() => ctx.root.$store.getters['driverView/getFetchingLicensesStatus'])
    const driverData = computed(() => store.getters['drivers/currentDriver'])
    return {
      driverData,
      fetchingLicenses,
    }
  },
}
</script>

<style>

</style>
